module.exports = __webpack_public_path__ + "assets/img/c754a93b7fd34c4d52ae2303b4e1d86f.svg";